export default __webpack_public_path__ + "static/media/hht1_storybook_07.a6113c3f.png";